// OrderHeader.js - FIXED VERSION
// Added support for custom copy handler that resets status
import React from 'react';
export default function OrderHeader({
  orderDetails,
  status,
  handleStatusChange,
  getStatusColor,
  isEditing,
  setIsEditing,
  handleSave,
  navigate,
  vehicles,
  prizes,
  getArtDueDate,
  getOrderResponseRate,  // NEW: Response rate function
  dealershipInfo,
  handleSendToJSDirect,
  handleSendToClient,  // NEW: Send to client handler
  handleCopyOrder  // FIXED: Accept custom copy handler
}) {
  const responseRate = getOrderResponseRate ? getOrderResponseRate() : null;
  
  return (
    <div className="view-order-header">
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
        <h1>#{orderDetails.jobNumber}</h1>
        {getArtDueDate() && (
          <div style={{ textAlign: 'center' }}>
            <p className="text-sm italic text-white opacity-90">
              Art Due Date: {getArtDueDate()}
            </p>
            {responseRate && (
              <p 
                className="text-sm font-semibold"
                style={{
                  marginTop: '4px',
                  color: '#ff9800'
                }}
              >
                Response Rate: {responseRate}%
              </p>
            )}
          </div>
        )}
      </div>
      <div className="client-actions" style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        paddingBottom: '20px',
      }}>
        <label className="text-sm font-medium text-white mb-2">Order Status</label>
        <select
          value={status}
          disabled={!isEditing}
          onChange={e => handleStatusChange(e.target.value)}
          className={`status-badge inline-block px-3 py-1 rounded-full text-sm font-semibold text-white ${getStatusColor()}`}
        >
          <option value="Incomplete - Need Art">Incomplete - Need Art</option>
          <option value="Pending Admin Approval">Pending Admin Approval</option>
          <option value="Pending Client Approval">Pending Client Approval</option>
          <option value="Art Complete - No Insurance">Art Complete - No Insurance</option>
          <option value="Art Complete - No Prizeboard">Art Complete - No Prizeboard</option>
          <option value="Pending Prizeboard Approval">Pending Prizeboard Approval</option>
          <option value="Order Complete">Order Complete</option>
          <option value="On Hold">On Hold</option>
          <option value="Cancelled">Cancelled</option>
        </select>
      </div>
      <div className="btn-group">
        {!isEditing ? (
          <button onClick={() => setIsEditing(true)}>Edit Order</button>
        ) : (
          <button onClick={handleSave}>Save Changes</button>
        )}
       
        <button onClick={handleCopyOrder || (() => {
          // FIXED: Fallback to original copy logic with status reset if no custom handler
          const { jobNumber, status, createdAt, updatedAt, clientId, ...everythingElse } = orderDetails;
          navigate('/orders/new', {
            state: {
              copiedOrder: {
                ...everythingElse,
                status: "Incomplete - Need Art"  // Reset status for copied orders
              },
              vehicles,
              prizes
            }
          });
        })}>
          Copy Order
        </button>
        <button onClick={handleSendToClient}>Send to Client</button>
        <button onClick={handleSendToJSDirect}>Send to JSDirect</button>
      </div>
    </div>
  );
}